import React, { useEffect, useState } from "react";

const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const [editCourse, setEditCourse] = useState(null);
  const [updatedTitle, setUpdatedTitle] = useState("");
  const [updatedSubtitles, setUpdatedSubtitles] = useState([""]);
  const [updatedPdf, setUpdatedPdf] = useState(null);
  const [updatedImage, setUpdatedImage] = useState(null);

  // ✅ Fetch Courses
  const fetchCourses = async () => {
    try {
      const response = await fetch("https://training.megascale.co.in/backend/get_courses.php");
      const data = await response.json();
      setCourses(data.courses);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  // ✅ Delete Course
  const deleteCourse = async (id) => {
    if (!window.confirm("Are you sure you want to delete this course?")) return;

    try {
      const response = await fetch("https://training.megascale.co.in/backend/delete_course.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ course_id: id }),
      });

      const result = await response.json();
      if (result.success) {
        alert("Course deleted successfully");
        fetchCourses();
      } else {
        alert("Failed to delete course");
      }
    } catch (error) {
      console.error("Error deleting course:", error);
    }
  };

  // ✅ Start Editing Course
  const startEdit = (course) => {
    setEditCourse(course.id);
    setUpdatedTitle(course.title);
    setUpdatedSubtitles(JSON.parse(course.subtitles));
  };

  // ✅ Update Subtitle
  const handleSubtitleChange = (index, value) => {
    const updatedSubs = [...updatedSubtitles];
    updatedSubs[index] = value;
    setUpdatedSubtitles(updatedSubs);
  };

  // ✅ Add New Subtitle
  const addSubtitle = () => {
    setUpdatedSubtitles([...updatedSubtitles, ""]);
  };

  // ✅ Remove Subtitle
  const removeSubtitle = (index) => {
    setUpdatedSubtitles(updatedSubtitles.filter((_, i) => i !== index));
  };

  // ✅ Handle File Uploads (PDF & Image)
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (type === "pdf") setUpdatedPdf(file);
    if (type === "image") setUpdatedImage(file);
  };

  // ✅ Save Edited Course
  const saveEdit = async () => {
    const formData = new FormData();
    formData.append("course_id", editCourse);
    formData.append("title", updatedTitle);
    formData.append("subtitles", JSON.stringify(updatedSubtitles));
    if (updatedPdf) formData.append("pdf", updatedPdf);
    if (updatedImage) formData.append("image", updatedImage);

    try {
      const response = await fetch("https://training.megascale.co.in/backend/update_course.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result.success) {
        alert("Course updated successfully!");
        setEditCourse(null);
        fetchCourses();
      } else {
        alert("Failed to update course");
      }
    } catch (error) {
      console.error("Error updating course:", error);
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6 pt-28">
      <h2 className="text-2xl font-bold text-blue-600 mb-4">Courses</h2>
      <div className="grid md:grid-cols-2 gap-4">
        {courses.map((course) => (
          <div key={course.id} className="border p-4 shadow-md rounded-lg bg-white">
            {editCourse === course.id ? (
              <>
                {/* ✅ Edit Title */}
                <input
                  type="text"
                  value={updatedTitle}
                  onChange={(e) => setUpdatedTitle(e.target.value)}
                  className="w-full border p-2 mb-2"
                />

                {/* ✅ Edit Subtitles */}
                {updatedSubtitles.map((subtitle, index) => (
                  <div key={index} className="flex space-x-2 mb-2">
                    <input
                      type="text"
                      value={subtitle}
                      onChange={(e) => handleSubtitleChange(index, e.target.value)}
                      className="w-full border p-2"
                    />
                    <button onClick={() => removeSubtitle(index)} className="px-3 py-1 bg-red-500 text-white rounded">✕</button>
                  </div>
                ))}
                <button onClick={addSubtitle} className="mt-2 text-blue-500 font-semibold hover:underline">+ Add Subtitle</button>

                {/* ✅ Upload PDF */}
                <div className="mt-3">
                  <label className="font-semibold">Upload PDF</label>
                  <input type="file" accept=".pdf" onChange={(e) => handleFileChange(e, "pdf")} />
                  {updatedPdf && <p>Selected: {updatedPdf.name}</p>}
                </div>

                {/* ✅ Upload Image */}
                <div className="mt-3">
                  <label className="font-semibold">Upload Image</label>
                  <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "image")} />
                  {updatedImage && <img src={URL.createObjectURL(updatedImage)} alt="Preview" className="w-32 h-20 mt-2 rounded-md" />}
                </div>

                <button onClick={saveEdit} className="bg-green-500 text-white p-2 rounded-md mt-3">Save</button>
              </>
            ) : (
              <>
                <h3 className="text-lg font-semibold">{course.title}</h3>
                <ul className="text-gray-600">
                  {JSON.parse(course.subtitles).map((sub, i) => (
                    <li key={i}>- {sub}</li>
                  ))}
                </ul>
                {course.pdf && <a href={`https://training.megascale.co.in/backend/${course.pdf}`} target="_blank" className="text-blue-500 block">📄 View PDF</a>}
                {course.image && <img src={`https://training.megascale.co.in/backend/${course.image}`} alt="Course" className="w-32 h-20 mt-2 object-cover rounded-md" />}
                
                <div className="flex space-x-2 mt-4">
                  <button onClick={() => startEdit(course)} className="bg-blue-500 text-white p-2 rounded-md">Edit</button>
                  <button onClick={() => deleteCourse(course.id)} className="bg-red-500 text-white p-2 rounded-md">Delete</button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseList;
